export class SiteLoader {
	constructor() {
		this.loader = document.querySelector('.site-loader');
		this.percentElement = document.querySelector('.site-loader__percent');
		this.percent = 0;
		this.init();
	}

	init() {
		if (!this.loader) return;

		// Симуляция загрузки
		this.animateLoading();
	}

	animateLoading() {
		const interval = setInterval(() => {
			this.percent += Math.random() * 15;
			
			if (this.percent >= 100) {
				this.percent = 100;
				clearInterval(interval);
				
				// Скрываем лоадер после завершения
				setTimeout(() => {
					this.hide();
				}, 500);
			}
			
			this.updatePercent();
		}, 200);
	}

	updatePercent() {
		if (this.percentElement) {
			this.percentElement.textContent = Math.floor(this.percent) + '%';
		}
	}

	hide() {
		if (this.loader) {
			this.loader.classList.add('site-loader--hidden');
			setTimeout(() => {
				if (this.loader) {
					this.loader.remove();
				}
				// Показываем прелоадер после скрытия SiteLoader
				if (window.preloader) {
					window.preloader.show();
				}
			}, 500);
		}
	}
}

